import script from "./Alert.vue?vue&type=script&setup=true&lang=js"
export * from "./Alert.vue?vue&type=script&setup=true&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=6d71692b&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d71692b"]])

export default __exports__